import Amplify, { Auth } from 'aws-amplify';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { StoreContext } from 'redux-react-hook';
import { makeStore } from './store';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme';

const { store, persistor } = makeStore();
console.log("REACT_APP_NOT_SECRET_CODE", process.env.REACT_APP_NOT_SECRET_CODE)

Amplify.configure({
    Auth: {
        mandatorySignIn: false,
        region: process.env.REACT_APP_REGION,
        userPoolId: process.env.REACT_APP_USERPOOL_ID,
        identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_APP_CLIENT_ID
    },
    Storage: {
        region: process.env.REACT_APP_STORAGE_REGION,
        bucket: process.env.REACT_APP_STORAGE_BUCKET,
        identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
    },
    API: {
        endpoints: [
            {
                name: process.env.REACT_APP_ENDPOINT_NAME,
                endpoint: process.env.REACT_APP_ENDPOINT_GATEWAY_URL,
                region: process.env.REACT_APP_ENDPOINT_REGION,
                
            },
            {
                name: process.env.REACT_APP_OLD_ENDPOINT_NAME,
                endpoint: process.env.REACT_APP_ENDPOINT_GATEWAY_URL,
                region: process.env.REACT_APP_ENDPOINT_REGION
            }
        ]
    }
});

ReactDOM.render(
    <StoreContext.Provider value={store}>
        <ThemeProvider theme={theme}>
            {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
            <CssBaseline />
            <App />
        </ThemeProvider>,
    {/* <App /> */}
    </StoreContext.Provider>
    , document.getElementById('root')

);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
